var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPregnant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.488,30.893c4.224,0,7.661-3.437,7.661-7.661s-3.437-7.661-7.661-7.661s-7.661,3.437-7.661,7.661 S40.264,30.893,44.488,30.893z M44.488,19.572c2.019,0,3.661,1.642,3.661,3.661s-1.642,3.661-3.661,3.661s-3.661-1.642-3.661-3.661 S42.469,19.572,44.488,19.572z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.264,40.652c-0.759-5.267-5.302-9.327-10.775-9.327c-6.003,0-10.887,4.884-10.887,10.887v23.711c0,1.104,0.896,2,2,2 h2.026v10.505c0,1.104,0.896,2,2,2h9.722c1.104,0,2-0.896,2-2V67.924h12.322c1.104,0,2-0.896,2-2V54.068 C65.672,47.692,61.3,42.19,55.264,40.652z M47.35,76.429h-5.722v-8.505h5.722V76.429z M61.672,63.924H49.35h-9.722h-2.026V42.212 c0-3.797,3.089-6.887,6.887-6.887s6.887,3.089,6.887,6.887v0.111c0,1.005,0.746,1.854,1.743,1.983 c4.877,0.631,8.554,4.828,8.554,9.761V63.924z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnant);
export default __webpack_public_path__ + "static/media/pregnant.657edaed0985af6f12a1a9e636cca3f6.svg";
export { ForwardRef as ReactComponent };